var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import React from "react";
import styled from "styled-components";
import { Tabs, Tab } from "../../../components/tabs";
import Flex from "../../../components/templates/flex";
import Mouse from "./mouse";
import Touch from "./touch";
var StyledTabs = styled(Tabs)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  width: 100%;\n\n  .tabs > * {\n    min-width: initial;\n    max-width: initial;\n  }\n"], ["\n  width: 100%;\n\n  .tabs > * {\n    min-width: initial;\n    max-width: initial;\n  }\n"])));
var Dashboard = function () { return (React.createElement(Flex, { overflow: { vertical: "auto" }, "data-testid": "dashboard" },
    React.createElement(StyledTabs, null,
        React.createElement(Tab, { label: "Using a Mouse" },
            React.createElement(Mouse, null)),
        React.createElement(Tab, { label: "Using Touch" },
            React.createElement(Touch, null))))); };
export default Dashboard;
var templateObject_1;
